module.exports = __webpack_public_path__ + "img/tutorial-thumbnail-01.c2b0f29c.jpg";